module.exports = __webpack_public_path__ + "static/img/banner3.b1be2d1e.png";